import React, { useMemo } from 'react';
import { connect } from 'react-redux';












const checkWritePermissions = (
entities = [],
user = undefined) =>
{
  let granted = user !== undefined && user.has('role') && entities.length > 0;
  let i = 0;
  while (granted && i < entities.length) {
    const entity = entities[i];
    i += 1;
    if (entity && entity.permissions) {
      const idsWithWritePermissions = entity.permissions.
      filter((p) => p.level === 'write').
      map((p) => p.refId);

      granted =
      idsWithWritePermissions.find(
        (id) => {var _user$get;return (
            id === user.get('_id') || ((_user$get = user.get('groups')) === null || _user$get === void 0 ? void 0 : _user$get.find((g) => g.get('_id') === id)));}
      ) !== undefined;
    } else {
      granted = false;
    }
  }
  return granted;
};

const checkRole = (user, roles = ['admin']) =>
!!(user.get('_id') && roles.includes(user.get('role')));

const NeedAuthorization = ({
  children,
  roles,
  orWriteAccessTo,
  user
}) => {
  const authorized = useMemo(
    () => checkRole(user, roles) || checkWritePermissions(orWriteAccessTo, user),
    [user, roles, orWriteAccessTo]
  );

  return authorized ? /*#__PURE__*/React.createElement(React.Fragment, null, children) : null;
};

const mapStateToProps = ({ user }) => ({ user });

export default connect(mapStateToProps)(NeedAuthorization);